// utils/dateFormatter.js
const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);

  const datePart = date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
  });

  const weekday = date.toLocaleDateString('en-GB', {
    weekday: 'short',
  });

  const timePart = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  return `${datePart} (${weekday}), ${timePart}`;
};

export default formatDateTime;
